import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { MailIcon, ArrowLeftIcon, CheckCircleIcon } from 'lucide-react';
const ForgotPassword = () => {
  const dk = useDarkClasses();
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
    }, 1500);
  };
  return <div className={`min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 ${dk.isDark ? 'bg-gray-900' : 'bg-gray-50'}`} data-id="element-6769" data-mp="n55f3kr44lx9">
      <div className={`max-w-md w-full space-y-8 p-10 rounded-xl shadow-lg ${dk.isDark ? 'bg-gray-800' : 'bg-white'}`} data-id="element-6770" data-mp="2hhv7tz5qvp32">
        <div className="text-center" data-id="element-6771" data-mp="2mfwral731qf2">
          <h2 className={`mt-6 text-3xl font-extrabold ${dk.isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-6772" data-mp="2mevfgei8szwa">
            Reset your password
          </h2>
          <p className={`mt-2 text-sm ${dk.isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-6773" data-mp="3vzyueu3ujhuf">
            Enter your email address and we'll send you a link to reset your
            password.
          </p>
        </div>

        {isSubmitted ? <div className={`mt-8 p-4 rounded-md ${dk.isDark ? 'bg-green-900/30 border border-green-800' : 'bg-green-50 border border-green-200'}`} data-id="element-6774" data-mp="3i0h1c2jipif9">
            <div className="flex" data-id="element-6775" data-mp="3d48qv2g9mdef">
              <div className="flex-shrink-0" data-id="element-6776" data-mp="3r1xay82idgif">
                <CheckCircleIcon className="h-5 w-5 text-green-400" aria-hidden="true" data-id="element-6777" data-mp="3qzkj936y7rs6" />
              </div>
              <div className="ml-3" data-id="element-6778" data-mp="16aepugv3tci9">
                <h3 className={`text-sm font-medium ${dk.isDark ? 'text-green-300' : 'text-green-800'}`} data-id="element-6779" data-mp="16dj0nx32r6hw">
                  Check your email
                </h3>
                <div className={`mt-2 text-sm ${dk.isDark ? 'text-green-200' : 'text-green-700'}`} data-id="element-6780" data-mp="3v43048vykqa8">
                  <p data-id="element-6781" data-mp="8xecam6s15rp">
                    We've sent a password reset link to <strong data-id="element-6782" data-mp="8xwctv0h265f">{email}</strong>
                    . Please check your inbox and spam folder.
                  </p>
                </div>
                <div className="mt-4" data-id="element-6783" data-mp="3ced81tjkyim0">
                  <Link to="/login" className={`text-sm font-medium ${dk.isDark ? 'text-green-300 hover:text-green-200' : 'text-green-800 hover:text-green-900'}`} data-id="element-6784" data-mp="3cfenea7mpr9j">
                    Return to login &rarr;
                  </Link>
                </div>
              </div>
            </div>
          </div> : <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-6785" data-mp="2tmarei6xv2br">
            <div data-id="element-6786" data-mp="2xopa92aly231">
              <label htmlFor="email-address" className={`block text-sm font-medium ${dk.isDark ? 'text-gray-300' : 'text-gray-700'} mb-1`} data-id="element-6787" data-mp="2xo5o19dxcrj7">
                Email address
              </label>
              <div className="relative" data-id="element-6788" data-mp="2l74mqm4rx6py">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-6789" data-mp="2h4hvamc0lnta">
                  <MailIcon className={`h-5 w-5 ${dk.isDark ? 'text-gray-500' : 'text-gray-400'}`} data-id="element-6790" data-mp="2c66hy1migv6b" />
                </div>
                <input id="email-address" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className={`appearance-none block w-full pl-10 pr-3 py-2 border ${dk.isDark ? 'border-gray-600 bg-gray-700 text-white placeholder-gray-400' : 'border-gray-300 bg-white text-gray-900 placeholder-gray-500'} rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm`} placeholder="you@example.com" data-id="element-6791" data-mp="278n6tal40yil" />
              </div>
            </div>

            <div data-id="element-6792" data-mp="3okepmy2v2dia">
              <button type="submit" disabled={isLoading} className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-6793" data-mp="39tfkxy55c93z">
                {isLoading ? <span className="flex items-center" data-id="element-6794" data-mp="2qvle9qrhq9or">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-6795" data-mp="2vtmyif0nkf1t">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-6796" data-mp="u1ros4xyikm8"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-6797" data-mp="2oax7u4pmf8ru"></path>
                    </svg>
                    Sending...
                  </span> : 'Send Reset Link'}
              </button>
            </div>
          </form>}

        <div className="mt-6 text-center" data-id="element-6798" data-mp="32ag33wxc2pmq">
          <Link to="/login" className="flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-6799" data-mp="1cuyu3njhzyka">
            <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-6800" data-mp="17xq799nen6cp" />
            Back to Login
          </Link>
        </div>
      </div>
    </div>;
};
export default ForgotPassword;